const loginAlert = msg => {
    alert(msg);
    window.location.href = '/#/login';
    return ;
}

export { loginAlert };